import HealthForceGoAPI, { HealthForceGoSkill } from '@/lib/HealthForceGoAPI';
import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex';

interface LocalState {
  skills: { [skillId: string]: HealthForceGoSkill };
  skillsCourseMap: { [courseId: string]: number[] };
  skillsLearningPlanMap: { [learningPlanId: string]: number[] };
}

Vue.use(Vuex);

const hfgAPI = HealthForceGoAPI.instance;

const namespaced = true;

const localState: LocalState = {
  skills: {},
  skillsCourseMap: {},
  skillsLearningPlanMap: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<LocalState, any> = {
  getSkillsForCourse: (state) => (courseId: number) => {
    const skillsArray: HealthForceGoSkill[] = [];
    const skills = state.skillsCourseMap[courseId] || [];
    skills.forEach((skillId) => {
      skillsArray.push(state.skills[skillId]);
    });
    return skillsArray;
  },

  getSkillsForLearningPlan: (state) => (learningPlanId: number) => {
    const skillsArray: HealthForceGoSkill[] = [];
    const skills = state.skillsLearningPlanMap[learningPlanId] || [];
    skills.forEach((skillId) => {
      skillsArray.push(state.skills[skillId]);
    });
    return skillsArray;
  },
};

const mutations: MutationTree<LocalState> = {
  SET_SKILLS: (state, skills: HealthForceGoSkill[]) => {
    const skillsObject: { [skillId: string]: HealthForceGoSkill } = {};
    const skillsCourseMap: { [courseId: string]: number[] } = {};
    const skillsLearningPlanMap: { [learningPlanId: string]: number[] } = {};
    skills.forEach((skill) => {
      skillsObject[skill.id] = skill;
      if (skill.lmsCourseIds) {
        skill.lmsCourseIds.forEach((courseId) => {
          if (!skillsCourseMap[courseId]) {
            skillsCourseMap[courseId] = [skill.id];
          } else {
            skillsCourseMap[courseId].push(skill.id);
          }
        });
      }
      if (skill.lmsLearningPlanIds) {
        skill.lmsLearningPlanIds.forEach((learningPlanId) => {
          if (!skillsLearningPlanMap[learningPlanId]) {
            skillsLearningPlanMap[learningPlanId] = [skill.id];
          } else {
            skillsLearningPlanMap[learningPlanId].push(skill.id);
          }
        });
      }
    });
    Vue.set(state, 'skills', skillsObject);
    Vue.set(state, 'skillsCourseMap', skillsCourseMap);
    Vue.set(state, 'skillsLearningPlanMap', skillsLearningPlanMap);
  },
};

const actions: ActionTree<LocalState, unknown> = {
  GET_SKILLS_DATA: (context): Promise<void> => {
    return hfgAPI.getSkillsData().then((skillsData) => {
      return context.commit('SET_SKILLS', skillsData.skills);
    });
  },
};

export { namespaced, localState as state, getters, mutations, actions };
